import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {OTPSession, OtpSessionDto, OtpSessionRequest} from '../../domain/otp/otp';
import {Media} from '../../domain/media/media';
import {HttpParamsUtil} from './utils/httpParams.util';

@Injectable({
    providedIn: 'root'
})
export class FrontOtpHttpService {

    constructor(private readonly http: HttpClient) {}


    orderOtp(alias: string, otpSessionRequest: OtpSessionRequest): Observable<Media> {
        return this.http.post<Media>(`/front/otp/stations/${alias}`, otpSessionRequest);
    }

    getActiveOtpMediaByCode(otpCode: string): Observable<Media> {
        return this.http.get<Media>(`/v2/front/otp/${otpCode}`);
    }

    openOtpSession(otpSessionRequest: OtpSessionRequest): Observable<OTPSession> {
        return this.http.post<OTPSession>(`/front/otp/session`, otpSessionRequest);
    }

    closeOtpSession(sessionId: string): Observable<void> {
        return this.http.post<void>(`/front/otp/session/${sessionId}/close`, {});
    }

    getOtpSession(sessionId: string): Observable<OTPSession> {
        return this.http.get<OTPSession>(`/front/otp/session/${sessionId}`);
    }

    getOtpSessionDto(sessionId): Observable<OtpSessionDto> {
        return this.http.get<OtpSessionDto>(`/v2/front/otp/session/${sessionId}`);
    }

    findOtpSessionByStationAliasAndCode(stationAlias: string, otpCode: string): Observable<OtpSessionDto> {
        return this.http.get<OtpSessionDto>(`/v2/front/otp/${otpCode}/station/${stationAlias}/session`);
    }

    findUnexpiredOtp(): Observable<OtpSessionDto[]> {
        return this.http.get<OtpSessionDto[]>(`/v2/front/otp/session/unexpired`);
    }

    findUnexpiredOtpByCode(otpCode: string, stationId: string, userEmail: string): Observable<OtpSessionDto> {
        return this.http.get<OtpSessionDto>(`/v2/front/otp/${otpCode}/stations/${stationId}/session/unexpired`,
            {
                params: HttpParamsUtil.toHttpParams({
                    userEmail: userEmail
                })
            });
    }
}
